import { CatalogoItemResponse } from "../../../shared/response/proyectos/CatalogoItemResponse";
import { CatalogoPrecioSavePayload } from "../../../shared/services/api/payload/proyectos/CatalogoPrecioSavePayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { CatalogoService } from "./CatalogoService";

/** Adaptador para editar el precio con `BaseSmallModalFormComponent` (delega en CatalogoService). */
export class CatalogoPrecioSaveService extends ServiceSaveBase<CatalogoItemResponse, CatalogoPrecioSavePayload> {
  /** Cambia el precio referencial: delega en `CatalogoService.updatePrecio` (gRPC `ActualizarPrecioCatalogo`). */
  protected sendSave(payload: CatalogoPrecioSavePayload): Promise<CatalogoItemResponse> {
    return CatalogoService.instance.updatePrecio(payload.id!, { precio: payload.precio, tipoP: payload.tipoP });
  }
}
